import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { motion } from "framer-motion";
import bullet from "../../assets/img/bullet.png";

const pageVariants = {
  initial: {
    opacity: 0,
    x: "-100vw",
    scale: 0.8,
  },
  in: {
    opacity: 1,
    x: 0,
    scale: 1,
  },
  out: {
    opacity: 0,
    x: "100vw",
    scale: 1.2,
  },
};

const pageTransition = {
  type: "tween",
  ease: "anticipate",
  duration: 0.5,
};

const pageStyle = {
  position: "absolute",
};

const Home = () => {
  return (
    <div className="my">
      <div
        animate={{
          scale: [1, 2, 2, 1, 1],
          rotate: [0, 90, 180, 270, 0],
          borderRadius: ["20%", "20%", "50%", "50%", "0%"],
        }}
        className="header"
      >
        <h1 className="headertitle" style={{ textAlign: "center" }}>
          My Blog's
        </h1>
        <div
          style={{
            position: "absolute",
            left: "30px",
            top: "100px",
            width: "140px",
          }}
        >
          <motion.svg
            whileHover={{ scale: 0.5 }}
            animate={{
              x: [
                20,
                40,
                60,
                80,
                100,
                120,
                140,
                160,
                180,
                200,
                220,
                240,
                260,
                280,
                300,
              ],
            }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              times: [0, 0.4, 0.8, 1.2, 1, 6, 2.0, 2.2, 2.4, 2.6, 2.8, 3],
              loop: Infinity,
              repeatDelay: 2,
            }}
            class="svg-icon"
            viewBox="0 0 20 20"
          >
            <path
              fill="white"
              d="M8.36,6.481C8.203,4.852,7.838,2.485,7.189,0.88C6.423,1.242,5.75,1.748,5.16,2.361C6.753,3.708,7.822,5.457,8.36,6.481z"
            ></path>
            <path
              fill="white"
              d="M14.84,2.361c-0.589-0.613-1.263-1.119-2.029-1.481c-0.649,1.606-1.014,3.972-1.171,5.602C12.178,5.457,13.247,3.708,14.84,2.361z"
            ></path>
            <path
              fill="white"
              d="M16.573,4.847c-2.402,1.185-3.636,2.637-3.657,2.662c-0.035,0.041-0.084,0.063-0.135,0.063c-0.039,0-0.078-0.013-0.111-0.039c-0.074-0.061-0.085-0.17-0.024-0.244c0.021-0.026,1.293-1.526,3.763-2.747c-0.384-0.699-0.827-1.347-1.332-1.919c-2.315,1.951-3.509,4.798-3.527,4.841c-0.006,0.016-0.021,0.025-0.031,0.038c-0.008,0.01-0.013,0.02-0.023,0.028c-0.031,0.025-0.067,0.042-0.107,0.042c-0.003,0-0.007,0-0.01,0c-0.003,0-0.004-0.003-0.007-0.003c-0.016-0.002-0.032-0.003-0.048-0.01c-0.013-0.005-0.017-0.02-0.028-0.028c-0.019-0.014-0.034-0.026-0.046-0.046c-0.012-0.019-0.017-0.037-0.021-0.059c-0.003-0.014-0.014-0.024-0.014-0.039c0.014-0.241,0.266-4.186,1.276-6.647C11.748,0.438,10.924,0.262,10,0.262c-0.924,0-1.748,0.176-2.493,0.478c1.01,2.462,1.261,6.407,1.276,6.647c0.001,0.015-0.011,0.025-0.014,0.039c-0.004,0.022-0.008,0.04-0.021,0.059c-0.013,0.02-0.027,0.032-0.046,0.046C8.691,7.539,8.687,7.553,8.674,7.559c-0.016,0.006-0.032,0.008-0.048,0.01c-0.003,0-0.004,0.003-0.007,0.003c-0.003,0-0.007,0-0.01,0c-0.04,0-0.076-0.017-0.107-0.042c-0.01-0.008-0.015-0.018-0.023-0.028c-0.01-0.013-0.024-0.022-0.031-0.038C8.43,7.42,7.236,4.573,4.921,2.622C4.416,3.194,3.974,3.841,3.589,4.541c2.47,1.221,3.742,2.721,3.763,2.747c0.061,0.074,0.05,0.183-0.024,0.244C7.296,7.559,7.256,7.572,7.218,7.572c-0.05,0-0.1-0.022-0.135-0.063c-0.02-0.025-1.255-1.477-3.657-2.662C0.961,9.619,0.958,16.405,0.958,16.405c0,0.688,0.578,1.246,1.292,1.246h2.882l1.728,1.458l1.256-0.628L10,19.738l1.885-1.256l1.256,0.628l1.728-1.458h2.882c0.713,0,1.292-0.558,1.292-1.246C19.042,16.405,19.039,9.619,16.573,4.847z M11.481,8.968h1.211c0.056,0.1,0.09,0.214,0.09,0.336c0,0.384-0.311,0.696-0.696,0.696s-0.696-0.311-0.696-0.696C11.391,9.182,11.426,9.068,11.481,8.968z M10,10.696c0.988,0,1.789,0.467,1.789,1.043c0,0.066-0.013,0.131-0.033,0.193c-0.084-0.026-0.172-0.044-0.265-0.044c-0.472,0-0.854,0.366-0.888,0.829c-0.189,0.04-0.39,0.065-0.603,0.065s-0.414-0.025-0.603-0.065c-0.034-0.463-0.416-0.829-0.888-0.829c-0.093,0-0.18,0.018-0.265,0.044c-0.02-0.063-0.033-0.127-0.033-0.193C8.211,11.163,9.012,10.696,10,10.696z M7.308,8.968h1.211c0.056,0.1,0.09,0.214,0.09,0.336C8.609,9.689,8.297,10,7.913,10c-0.384,0-0.696-0.311-0.696-0.696C7.218,9.182,7.252,9.068,7.308,8.968z M4.783,14.521c0,0.192-0.156,0.348-0.348,0.348s-0.348-0.156-0.348-0.348c0-1.44,1.418-2.648,3.494-3.182c-0.04,0.128-0.066,0.26-0.066,0.4c0,0.109,0.025,0.22,0.055,0.333C5.928,12.547,4.783,13.477,4.783,14.521z M12.772,15.754c-0.026,0.103-0.118,0.171-0.219,0.17H8.207H8.005c-0.438-0.002-0.792-0.382-0.79-0.825c0.002-0.443,0.359-0.8,0.797-0.798c0.066,0,0.134,0.01,0.195,0.026l4.346,1.136l0.057,0.015C12.731,15.508,12.803,15.632,12.772,15.754z M15.565,14.869c-0.192,0-0.348-0.156-0.348-0.348c0-1.044-1.145-1.975-2.787-2.449c0.03-0.113,0.055-0.224,0.055-0.333c0-0.139-0.026-0.272-0.066-0.4c2.076,0.534,3.494,1.742,3.494,3.182C15.912,14.713,15.757,14.869,15.565,14.869z"
            ></path>
          </motion.svg>
        </div>
        <div
          style={{
            position: "absolute",
            right: "30px",
            top: "130px",
            width: "140px",
          }}
        >
          <motion.img
            src={bullet}
            animate={{
              x: [
                -40,
                -80,
                -120,
                -180,
                -240,
                -300,
                -350,
                -400,
                -500,
                -600,
                -700,
              ],
            }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              times: [0, 0.3, 0.5, 0.9, 1.25, 1.5, 1.7, 2, 2.5, 3],
              loop: Infinity,
              repeatDelay: 2,
            }}
          />
        </div>
        <div
          style={{
            position: "absolute",
            right: "30px",
            top: "100px",
            width: "140px",
          }}
        >
          <motion.svg
            whileHover={{ scale: 0.5 }}
            animate={{
              x: [
                -20,
                -40,
                -60,
                -80,
                -100,
                -120,
                -140,
                -160,
                -180,
                -200,
                -220,
                -240,
                -260,
                -300,
              ],
            }}
            transition={{
              duration: 3,
              ease: "easeInOut",
              times: [0, 0.4, 0.8, 1.2, 1, 6, 2.0, 2.2, 2.4, 2.6, 2.8, 3],
              loop: Infinity,
              repeatDelay: 2,
            }}
            class="svg-icon"
            viewBox="0 0 20 20"
            enable-background="new 0 0 20 20"
          >
            <circle fill="white" cx="3.274" cy="6.198" r="0.585"></circle>
            <rect
              x="6.198"
              y="4.736"
              fill="white"
              width="0.585"
              height="2.34"
            ></rect>
            <path
              fill="white"
              d="M15.849,11.669v-1.064l-1.072-0.715l-0.829,1.659c-0.428,0.174-0.73,0.592-0.73,1.083c0,0.265,0.091,0.507,0.24,0.703l-0.201,2.806h1.759l0.191-2.676c0.216-0.212,0.35-0.507,0.35-0.833c0-0.102-0.017-0.2-0.042-0.294L15.849,11.669z M14.387,13.217c-0.322,0-0.585-0.262-0.585-0.585c0-0.322,0.262-0.585,0.585-0.585c0.322,0,0.585,0.262,0.585,0.585C14.971,12.954,14.709,13.217,14.387,13.217z"
            ></path>
            <polygon
              fill="white"
              points="15.721,7.368 19.066,7.368 19.066,3.859 16.141,2.894 15.556,2.104 11.462,2.104 10.877,2.894 8.538,3.859 8.538,7.368 11.297,7.368 	"
            ></polygon>
            <path
              fill="white"
              d="M5.029,7.368h0.585V4.444h-2.34l-1.755,1.17v0.877H0.496c-0.081,0-0.146,0.065-0.146,0.146s0.065,0.146,0.146,0.146h1.024v0.585H0.642C0.48,7.368,0.35,7.499,0.35,7.66S0.48,7.953,0.642,7.953h3.802L5.029,7.368zM3.274,7.076c-0.485,0-0.877-0.393-0.877-0.877s0.393-0.877,0.877-0.877s0.877,0.393,0.877,0.877S3.758,7.076,3.274,7.076z"
            ></path>
            <path
              fill="white"
              d="M18.96,16.141l-0.631-2.944c0.094-0.168,0.151-0.359,0.151-0.565c0-0.295-0.113-0.561-0.292-0.766v-1.427l0.71-2.486H9.708c-0.646,0-1.17,0.524-1.17,1.17c0,0.162,0.033,0.317,0.093,0.457l-0.682,2.047c-0.346,0.203-0.58,0.575-0.58,1.005c0,0.152,0.031,0.297,0.084,0.431l-1.099,3.079h1.863l0.407-1.141l1.504,0.725l0.761-1.581l-1.51-0.711c0.201-0.209,0.33-0.488,0.33-0.801c0-0.162-0.033-0.316-0.093-0.457l0.556-1.668l1.73-1.384h2.778l1.755,1.17v1.48v0.093c-0.18,0.206-0.292,0.472-0.292,0.766c0,0.392,0.195,0.738,0.492,0.95l0.536,2.559H18.96z M8.538,13.217c-0.322,0-0.585-0.262-0.585-0.585c0-0.322,0.262-0.585,0.585-0.585c0.322,0,0.585,0.262,0.585,0.585C9.123,12.954,8.86,13.217,8.538,13.217z M9.708,9.708c-0.322,0-0.585-0.262-0.585-0.585c0-0.322,0.262-0.585,0.585-0.585c0.322,0,0.585,0.262,0.585,0.585C10.292,9.445,10.03,9.708,9.708,9.708z M17.311,8.538c0.322,0,0.585,0.262,0.585,0.585c0,0.322-0.262,0.585-0.585,0.585s-0.585-0.262-0.585-0.585C16.726,8.8,16.988,8.538,17.311,8.538z M16.726,12.632c0-0.322,0.262-0.585,0.585-0.585s0.585,0.262,0.585,0.585c0,0.322-0.262,0.585-0.585,0.585S16.726,12.954,16.726,12.632z"
            ></path>
            <rect
              x="7.368"
              y="4.736"
              fill="white"
              width="0.585"
              height="2.34"
            ></rect>
            <polygon
              fill="white"
              points="11.89,14.086 11.468,14.288 10.517,16.265 10.622,16.721 11.413,17.101 12.68,14.466 	"
            ></polygon>
            <polygon
              fill="white"
              points="19.285,16.726 17.092,16.726 16.726,17.019 16.726,17.896 19.65,17.896 19.65,17.019 	"
            ></polygon>
            <polygon
              fill="white"
              points="12.997,16.726 12.632,17.019 12.632,17.896 15.556,17.896 15.556,17.019 15.191,16.726 	"
            ></polygon>
            <polygon
              fill="white"
              points="5.979,16.726 5.613,17.019 5.613,17.896 8.538,17.896 8.538,17.019 8.172,16.726 	"
            ></polygon>
            <path
              fill="white"
              d="M5.933,13.752l0.558,0.263l0.344-0.963c-0.035-0.138-0.052-0.278-0.052-0.419c0-0.536,0.253-1.044,0.672-1.375l0.634-1.903l-2.461,2.109c-0.005,0-0.01-0.002-0.015-0.002c-0.646,0-1.17,0.524-1.17,1.17c0,0.646,0.524,1.17,1.17,1.17C5.725,13.802,5.831,13.781,5.933,13.752z M5.029,12.632c0-0.322,0.262-0.585,0.585-0.585s0.585,0.262,0.585,0.585c0,0.322-0.262,0.585-0.585,0.585S5.029,12.954,5.029,12.632z"
            ></path>
          </motion.svg>
        </div>
      </div>
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransition}
        className="bloglist"
      >
        <h1 style={{ paddingTop: "100px" }} className="blogtitle">
          An Online Shopping Cart App with Express.js,GraphQL Api, mongoDB,
          React Native, ApolloGraphql, Redux.
        </h1>
        <NavLink activeStyle={{ color: "red" }} to="/blog">
          <motion.h2
            whileHover={{ scale: 0.7 }}
            whileTap={{ scale: 0.9 }}
            className="blogsubtitle"
          >
            Part 1 Making GraphQl Api with Express.js, mongoDB.
          </motion.h2>
        </NavLink>
      </motion.div>
    </div>
  );
};

export default Home;
